import BarItem, {
  barItem,
  ValueItem,
  ValueItemType
} from "@/components/common/shared/InformationBar/BarItem"
import { Grid, TypographyVariant } from "@material-ui/core"
import { uniqueId } from "lodash"
import React from "react"
import { useHistory, useLocation } from "react-router"

export type barItems = Array<barItem | ValueItemType | undefined>

const isBarItem = (item: barItem | ValueItemType): item is barItem => {
  return (item as barItem).title !== undefined
}

export type TypographyColor =
  | "inherit"
  | "initial"
  | "textSecondary"
  | "primary"
  | "secondary"
  | "textPrimary"
  | "error"

const InformationBar = ({
  data,
  isGrid,
  color,
  variant
}: {
  data: barItems
  isGrid?: boolean
  color?: TypographyColor
  variant?: TypographyVariant
}) => {
  const history = useHistory()
  const location = useLocation()
  const handleClick = (
    hasLink?: boolean,
    goBack?: boolean,
    pathToNavigate?: string
  ) => {
    // must use location.pathname because unmutable
    if (location.pathname === pathToNavigate) {
      // same path, no navigation, otherwise the state breaks
      return
    }

    if (hasLink) {
      if (goBack) {
        history.goBack()
      } else if (pathToNavigate) {
        history.push(pathToNavigate)
      } else {
        window.location.reload()
      }
    }
  }
  const nonUndefData = data.filter ? data?.filter(Boolean) : []

  return (
    <>
      {nonUndefData.map(e => {
        const Bar = () => (
          <BarItem
            key={uniqueId("infoBarItem")}
            value={e?.value}
            title={e && isBarItem(e) ? e.title : ""}
            formatter={e?.formatter}
            color={color}
            variant={variant}
            hasLink={e?.hasLink}
            goBack={e?.goBack}
            onClick={() =>
              handleClick(e?.hasLink, e?.goBack, e?.pathToNavigate)
            }
          />
        )

        return e && isBarItem(e) ? (
          isGrid ? (
            <Grid item key={uniqueId("gridBar")}>
              <Bar />
            </Grid>
          ) : (
            <Bar key={uniqueId("bar")} />
          )
        ) : (
          <ValueItem
            key={uniqueId("vItem")}
            value={e?.value}
            formatter={e?.formatter}
            color={color}
            variant={variant}
          />
        )
      })}
    </>
  )
}

export default InformationBar
